<div class="overlay-spinner" *ngIf="LoaderStatus">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-warning" style="width: 3rem; height: 3rem; " role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
<app-alert [Type]="AlertType" [View]="AlertStatus" [Message]="AlertMessage"></app-alert>
<div class="mx-5 pb-5">
  <app-pages-header></app-pages-header>
  <div class="bg-white mx-1 bottom-page-shadow rounded-bottom-extra pb-5">
    <div class="row ps-3 pt-4">
      <div class="col">
        <p> <span class="fw-bold">Integrasi</span> - MITRS </p>
      </div>
    </div>
    <div class="row">
      <div class="col pt-3 mx-5 ">
        <p class="text-muted">Sila pilih Ejen Cukai</p>
      </div>
    </div>
    <div class="row pb-5">
      <div class="col-5 mx-5">
        <select class="form-select border-0 shadow" [(ngModel)]="InputAgentIDNo" [ngModelOptions]="{standalone: true}">
          <option value="">Ejen Cukai</option>
          <option *ngFor="let res of AgentList" [value]="res.taxAgentIDNo">{{res.taxAgentName}}</option>
        </select>
        <!-- <input type="text" class="form-control border-0 shadow" placeholder="TIN"> -->
      </div>
      <div class="col-4">
        <div class="btn-toolbar d-flex justify-content-start">
          <div class="me-2">
            <button type="button" class="btn submit-button border-0 shadow rounded-2" role="button" (click)="Submit(InputAgentIDNo)">Hantar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

